let LoginStatus;
export default LoginStatus = {
    NotRegistered: 0,
    isRegistered: 1,
}
